module.exports = "/images/medcrum.jpeg?53473809d5ab8820ff1a0b1175c0bec0";